import Link from "next/link";
import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import { portalRoutes } from "@nju/routes";
import { A, Button, Text, TextStyleProps } from "@nju/ui";

interface IChangePaymentButtonProps {
  isPending: boolean;
  openModal?: () => void;
  tone: TextStyleProps["tone"];
  mode: IOfferModeWithFSecure;
  userId: string | undefined;
}

export function ChangePaymentButton({
  isPending,
  openModal,
  tone,
  mode,
  userId,
}: IChangePaymentButtonProps) {
  return (
    <>
      {isPending && openModal && (
        <Button
          align="left"
          display="inline"
          onPress={openModal}
          size="inline"
          variant="neutral"
        >
          <Text className="underline" display="inline" tone={tone}>
            zmień metodę płatności
          </Text>
        </Button>
      )}
      {!isPending && (
        <div>
          <Link
            href={portalRoutes.mojeKonto.platnosci.index.get({
              zmianaMetodyPlatnosci: "1",
              mode,
              ...(userId && { userId }),
            })}
          >
            <A align="left" display="inline" size="inline" variant="simple">
              <Text className="underline" display="inline" tone={tone}>
                zmień metodę płatności
              </Text>
            </A>
          </Link>
        </div>
      )}
    </>
  );
}
